import type { AIAssistantQuestionType, AICredits } from '@/types/ai-assistant'

export type AIAssistantState = {
  questionType: AIAssistantQuestionType | null
  conversationActiveId: string | null
  conversations: Array<any>
  credits: AICredits | null
  creditsPending: boolean
  getConversationsPending: boolean
  getConversationMessagesPending: boolean
  isPaneOpened: boolean
  postPromptPending: boolean
  postPromptStreaming: boolean
  pendingConversationId: string | null
}

export const state: AIAssistantState = {
  questionType: null,
  conversationActiveId: null,
  conversations: [],
  credits: null,
  creditsPending: false,
  getConversationsPending: false,
  getConversationMessagesPending: false,
  isPaneOpened: false,
  postPromptPending: false,
  postPromptStreaming: false,
  pendingConversationId: null,
}
